import React from 'react';

import { spacing } from '@rbilabs/universal-components/themes';
import { Text } from 'native-base';
import { useIntl } from 'react-intl';
import { View } from 'react-native';
import { StyleSheet } from 'react-native';

import { StyledLoyaltyPointsIcon } from 'components/loyalty-points-button/styled';
import { selectors, useAppSelector } from 'state/global-state';
import { primitive } from 'styles/constants/primitives';

export const HeaderPoints = React.memo(() => {
  const availablePoints = useAppSelector(selectors.loyalty.selectStagedCartPoints);
  const { formatMessage } = useIntl();

  return (
    <View
      style={styles.container}
      accessibilityLabel={`${String(availablePoints)} ${formatMessage({
        id: 'points',
      })}`}
    >
      <Text variant="headerFourLook" style={styles.text}>
        {String(availablePoints)}
      </Text>
      <StyledLoyaltyPointsIcon reversed={false} />
    </View>
  );
});

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  text: {
    color: primitive.bk.$mayoEggWhite,
    marginBottom: 0,
    marginRight: spacing.$2,
  },
});
